import ExpertContactController from './expert-contact.controller';
import template from './expert-contact.html';
import './expert-contact.less';

const ExpertContactContainer = {
  bindings: {},
  template,
  controller: ExpertContactController
};

export default ExpertContactContainer;



// WEBPACK FOOTER //
// ./src/containers/expert-contact/expert-contact.component.js